import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Pencil, Trash2, Star } from "lucide-react";
import { Header, EditModal, Grid2, Input, TextArea } from "./AdminSimulators";

const empty = { name: "", role: "", company: "", quote: "", rating: 5, avatar_url: "", order: 0, active: true };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => setItems((await api.get("/admin/testimonials")).data);
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/testimonials/${editing.id}`, editing);
      else await api.post("/admin/testimonials", editing);
      toast.success("Salvo");
      setEditing(null);
      load();
    } catch (e) { toast.error("Erro"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir?")) return;
    await api.delete(`/admin/testimonials/${id}`);
    load();
  };

  return (
    <div data-testid="admin-testimonials">
      <Header title="Depoimentos" onCreate={() => setEditing({ ...empty })} />
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((t) => (
          <div key={t.id} className="rounded-xl border border-white/5 bg-[#0a0a0a] p-6">
            <div className="flex gap-1 mb-3">
              {Array.from({ length: t.rating }).map((_, i) => <Star key={i} className="w-4 h-4 fill-[#008CFF] text-[#008CFF]" />)}
            </div>
            <p className="text-white leading-relaxed">"{t.quote}"</p>
            <div className="mt-4 flex items-center justify-between">
              <div>
                <div className="font-semibold">{t.name}</div>
                <div className="text-xs text-neutral-500">{t.role}{t.company ? ` · ${t.company}` : ""}</div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => setEditing(t)} className="p-2 rounded-lg border border-white/10 hover:border-[#008CFF]"><Pencil className="w-3 h-3" /></button>
                <button onClick={() => remove(t.id)} className="p-2 rounded-lg border border-white/10 hover:border-[#E31B23]"><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <EditModal onClose={() => setEditing(null)} onSave={save} title={editing.id ? "Editar depoimento" : "Novo depoimento"}>
          <Grid2>
            <Input label="Nome*" v={editing.name} on={(v) => setEditing({ ...editing, name: v })} />
            <Input label="Cargo" v={editing.role} on={(v) => setEditing({ ...editing, role: v })} />
            <Input label="Empresa" v={editing.company} on={(v) => setEditing({ ...editing, company: v })} />
            <Input label="Nota (1-5)" type="number" v={editing.rating} on={(v) => setEditing({ ...editing, rating: Math.min(5, Math.max(1, Number(v))) })} />
          </Grid2>
          <TextArea label="Depoimento*" v={editing.quote} on={(v) => setEditing({ ...editing, quote: v })} rows={4} />
          <Grid2>
            <Input label="URL do avatar" v={editing.avatar_url} on={(v) => setEditing({ ...editing, avatar_url: v })} />
            <Input label="Ordem" type="number" v={editing.order} on={(v) => setEditing({ ...editing, order: Number(v) })} />
          </Grid2>
          <label className="flex items-center gap-2"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({ ...editing, active: e.target.checked })} /> <span>Ativo</span></label>
        </EditModal>
      )}
    </div>
  );
}
